import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { shared } from "../styles";

@customElement("ptc-floating-form-buttons")
export class FloatingFormButtons extends LitElement {
    static styles = [shared];

    render() {
        return html`
            <div>
                <div
                    class="horizontal spacing evenly stretching padded layout"
                    style="max-width: 50em; margin: 0 auto;"
                >
                    <button
                        class="primary"
                        @click=${() => {
                            this.dispatchEvent(
                                new CustomEvent("save", {
                                    bubbles: true,
                                    composed: true,
                                })
                            );
                        }}
                    >
                        Speichern
                    </button>
                    <button
                        class="transparent"
                        @click=${() => {
                            this.dispatchEvent(
                                new CustomEvent("cancel", {
                                    bubbles: true,
                                    composed: true,
                                })
                            );
                        }}
                    >
                        Abbrechen
                    </button>
                </div>
            </div>
        `;
    }
}
